import React from 'react';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import style from './style.module.scss';


function Help() {
  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={style.back_white_wrap} style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={'ヘルプ'} hasBackIcon={true} hasHamburger={true} />
        <div style={{ paddingTop: '50px' }}>
          <iframe src={`/webview_web/Help/help_web.html`} title="ヘルプ" />
        </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default Help;
